import { BreadcrumbConfigProps } from "./InterfacesAndTypes";

export const defaultBreadcrumbPath = [{ name: "Dashboard", link: "/" }];

export const UserBreadcrumb: BreadcrumbConfigProps = {
  title: "User Management",
  path: [ { name: "Users Management" }],
};

export const RoleBreadcrumb: BreadcrumbConfigProps = {
  title: "Roles Management",
  path: [ { name: "Roles" }],
};

export const CMSSettingsBreadcrumb: BreadcrumbConfigProps = {
  title: "CMS Settings",
  path: [ { name: "Settings" }, { name: "CMS" }],
};

export const HomePageSettingsBreadcrumb: BreadcrumbConfigProps = {
  title: "Home Page Settings",
  path: [ { name: "Settings" }, { name: "Home Page" }],
};

export const RaceBreadcrumb: BreadcrumbConfigProps = {
  title: "Ethnicity",
  path: [ { name: "Masters" }, { name: "Ethnicities" }],
};

export const VeteranStatusBreadcrumb: BreadcrumbConfigProps = {
  title: "Veteran Status Management",
  path: [ { name: "Masters" }, { name: "Military Status" }],
};

export const VrTrainingLocationBreadcrumb: BreadcrumbConfigProps = {
  title: "Locations",
  path: [ { name: "Masters" }, { name: "Locations" }],
};
export const InterestDiscoveryBreadcrumb: BreadcrumbConfigProps = {
  title: "Interest Discovery",
  path: [ { name: "Interest Discovery" }],
};
export const SkillPoratraitBreadcrumb: BreadcrumbConfigProps = {
  title: "Skill Portrait",
  path: [ { name: "Skill Portrait" }],
};

export const TestimonialBreadcrumb: BreadcrumbConfigProps = {
  title: "Testimonial",
  path: [ { name: "Masters" }, { name: "Testimonials" }],
};

export const CertificationsBreadcrumb: BreadcrumbConfigProps = {
  title: "Certifications",
  path: [ { name: "Masters" }, { name: "Certifications" }],
};

export const CareerBreadcrumb: BreadcrumbConfigProps = {
  title: "Career",
  path: [ { name: "Masters" }, { name: "Careers" }],
};

export const SkillCategoriesBreadcrumb: BreadcrumbConfigProps = {
  title: "Skill Categories",
  path: [ { name: "Masters" }, { name: "Skill Categories" }],
};

export const CareerCategoriesBreadcrumb: BreadcrumbConfigProps = {
  title: "Career Categories",
  path: [ { name: "Masters" }, { name: "Career Categories" }],
};

export const OccupationalGroupsBreadcrumb: BreadcrumbConfigProps = {
  title: "Occupational Groups",
  path: [ { name: "Masters" }, { name: "Occupational Groups" }],
};

export const EducationTrainingBreadcrumb: BreadcrumbConfigProps = {
  title: "Education Training",
  path: [ { name: "Masters" }, { name: "Education Training" }],
};

export const ExperienceBreadcrumb: BreadcrumbConfigProps = {
  title: "Experience",
  path: [ { name: "Masters" }, { name: "Experience" }],
};

export const CareerPathBreadcrumb: BreadcrumbConfigProps = {
  title: "Career Path",
  path: [ { name: "Masters" }, { name: "Career Path" }],
};

export const CustomerAccessBreadcrumb: BreadcrumbConfigProps = {
  title: "Access Codes",
  path: [ { name: "Access Codes" }],
};

export const CompanyBreadcrumb: BreadcrumbConfigProps = {
  title: "Customer",
  path: [ { name: "Customers" }],
};


export const IndustryBreadcrumb: BreadcrumbConfigProps = {
  title: "Industry",
  path: [{ name: "Masters" }, { name: "Industries" }],
};

export const DashboardBreadcrumb: BreadcrumbConfigProps = {
  title: "Dashboard",
  path: [{ name: "Dashboard" }],
};

export const AcronymsBreadcrumb: BreadcrumbConfigProps = {
  title: "Acronyms",
  path: [{ name: "Masters" }, { name: "Acronyms" }],
};

export const CurriculumBreadcrumbDetails: BreadcrumbConfigProps & any = (name=null)=> ({
  title: "Curriculum",
  path: [ { name: "Curriculum"  }, {name: name ? name : "Curriculum Details"}],

});


export const CareerGroupBreadcrumb: BreadcrumbConfigProps = {
  title: "Career Group",
  path: [ { name: "Masters" }, { name: "Career Group" }],
};



export const ImportActivityBreadcrumb: BreadcrumbConfigProps = {
  title: "Import Activity",
  path: [ { name: "Import Activity" }],
};


export const ActivityLogBreadcrumb: BreadcrumbConfigProps = {
  title: "Activity Log",
  path: [ { name: "Activity Log" }],
};

